module.exports = __webpack_public_path__ + "img/ico-trash.74d4d0f7.svg";